import React, { useState } from "react";
import Tabs from "../../widgets/tabs";
import ClientConnectionModal from "./ClientConnectionModal";
import {clientConnectionStandards} from "../../constants/app.constants";

const tabData = [
  { label: "Overview", path: "Overview"},
  { label: "Client Connection", path: "ClientConnection"},
  { label: "Invoicing", path: "Invoicing"},
  { label: "Scheduling", path: "Scheduling"},
  { label: "Quotes", path: "Quotes"},
];

const ClientConnection: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="container-fluid">
      <div className="body-content">
        <Tabs tabs={tabData} activeTabIndex={1} />
        <div className="hero">
            <div className="hero-inner">
            <h1>CLIENT CONNECTION</h1>
            </div>
        </div>
  
        <div className="content-info">
            <p>
            Just a friendly reminder to schedule your weekly meeting with our
            operations team at your earliest convenience by clicking the link
            above.
          </p>
          <div className="client-connection-trigger">
            <button className="green-btn" onClick={() => setIsOpen(true)}>
              WHAT IS A CLIENT CONNECTION MEETING?
            </button>
            <a
              className="green-btn"
              href="https://calendly.com/d/crs2-3rp-k88/benchmark-client-connection"
              target="_blank"
              rel="noreferrer"
            >
              SCHEDULE YOUR MEETING
            </a>
          </div>
        </div>
        <div className="client-connection-image-section">
          <div className="client-connection-image-wrap">
            <img
              className="client-connection-image"
              src={clientConnectionStandards}
              alt="Benchmark client connection standards"
            />
          </div>
        </div>
      </div>

      <ClientConnectionModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
};

export default ClientConnection;
